import ColumnAndItemSummaryLayout from "./ColumnAndItemSummaryLayout";
import DetailsForm from "./DetailsForm";
import HeadingMain from "./HeadingMain";
import React from "react";
import { useAppContext } from "./AppContext";

function OnlineAddDetails() {
  const { takebackItems, donatedTakebackItems } = useAppContext();

  return (
    <ColumnAndItemSummaryLayout
      itemsEditable={true}
      items={takebackItems}
      donations={donatedTakebackItems}
      columnContent={
        <>
          <HeadingMain pb={[40, 40, 80, 80]}>
            We just need a few details to complete your takeback
          </HeadingMain>
          <DetailsForm />
        </>
      }
    />
  );
}

export default OnlineAddDetails;
